<i18n src="@/locales/modules/EmployeeTranslate.json"></i18n>

<template>
	<CbsContextMenu
		v-if="
			employee.can_update ||
				mixinIsCanViewAllEmployee ||
				mixinIsCanCreateEmployee ||
				(employee.can_cancel && employee.type === 0) ||
				(employee.readableProperties && employee.readableProperties.is_cancel && mixinIsCanCreateTodo)
		"
		v-bind="$attrs"
		:class="['todo-context-menu', { 'mr-5': displayMode === 'detail' }]"
		:menuListDataBinding="{ class: 'todo-context-menu-list' }"
	>
		<div v-if="mixinIsCanViewAllContract" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onDownloadKPI', employee.id)">
			<i class="nucleo mr-3 nucleo-file-download-94" />
			{{ $t("ExportKpi") }}
		</div>
		<div v-if="mixinIsCanViewAllContract" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onViewContract', employee)">
			<i class="nucleo mr-3 nucleo-file-text01" />
			{{ $t("LaborContract") }}
		</div>
		<div v-if="employee.can_update" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onDivisionCustomer', employee)">
			<i class="nucleo mr-3 nucleo-recipe-create-3" />
			{{ $t("Assignment") }}
		</div>

		<div v-if="employee.can_update" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onEdit', employee.id)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>

		<div v-if="mixinIsCanViewAllEmployee && employee.is_student" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onViewStudentProfile', employee.id)">
			<i class="nucleo mr-3 nucleo-users-mm" />
			{{ $t("ProfileDormitory.ViewProfileStudent") }}
		</div>

		<div v-if="mixinIsCanViewAllEmployee && employee.is_student" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onViewStudentData', employee.id)">
			<i class="nucleo mr-3 nucleo-file-paragraph" />
			{{ $t("ProfileDormitory.StudentData") }}
		</div>

		<div v-if="mixinIsCanViewAllEmployee && employee.is_student" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onViewStudentPoint', employee.id)">
			<i class="nucleo mr-3 nucleo-file-paragraph" />
			{{ $t("ProfileDormitory.Point") }}
		</div>

		<div v-if="employee.can_delete" class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap" @click="$emit('onDelete', employee.id)">
			<i class="nucleo mr-3 nucleo-trash-can" />
			{{ $t("DeleteEmployee") }}
		</div>

		<div
			v-if="employee.user && employee.user.is_activated && employee.user.can_update"
			class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onBlock', { id: employee.id, block: true, name: employee.name })"
		>
			<i class="nucleo mr-3 nucleo-padlock" />
			{{ $t("BlockAccount") }}
		</div>
		<div
			v-if="employee.user && !employee.user.is_activated && employee.user.can_update"
			class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onUnBlock', { id: employee.id, block: false, name: employee.name })"
		>
			<i class="nucleo mr-3 nucleo-cmunlock-outline" />
			{{ $t("UnBlockAccount") }}
		</div>
		<div
			v-if="!employee.user && employee.can_update && mixinIsCanCreateBackendUser"
			class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onCreateAccount', employee.id)"
		>
			<i class="nucleo mr-3 nucleo-cmadd" />
			{{ $t("CreateAccount") }}
		</div>
		<div
			v-if="employee.user && employee.user.is_activated && employee.user.can_update"
			class="todo-context-menu-list__item text-black flex items-center whitespace-no-wrap"
			@click="$emit('onResetPassword', employee)"
		>
			<i class="nucleo mr-3 nucleo-cmpassword" />
			{{ $t("ResetPassword") }}
		</div>
	</CbsContextMenu>
	<span v-else></span>
</template>

<script>
import { employeePermissions, contractPermissions, getUserPermissions, backendUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "EmployeeContextMenu",
	mixins: [getUserPermissions({ ...employeePermissions, ...backendUserPermissions, ...contractPermissions })],
	components: { CbsContextMenu },
	props: {
		employee: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickCancel: {},
		onClickRecreate: {},
		onClickCreateRequest: {}
	}
};
</script>

<style lang="scss" scoped>
.todo-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.todo-context-menu-list {
	.todo-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
